import { render } from "./DownloadResultsButtonGroup.vue?vue&type=template&id=3f56382c"
import script from "./DownloadResultsButtonGroup.vue?vue&type=script&lang=js"
export * from "./DownloadResultsButtonGroup.vue?vue&type=script&lang=js"
script.render = render

export default script